const useOs = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(userAgent);
  const isAndroid = /android/.test(userAgent);
  const isOther = !isIOS && !isAndroid;

  return {
    isIOS,
    isAndroid,
    isOther,
    isMobile: isIOS || isAndroid,
  };
};

export default useOs;
